var path = 'src/app/forms/fields/text-field.html';
var html = "<input frm-model frm-required ng-required=required() ng-model=model ng-attr-ng-maxlength=\"{{ maxlength }}\" type=text class=form-control /> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/forms/fields/text-field.html
 ** module id = 304
 ** module chunks = 0
 **/